import React from 'react';
import '../styles/ProjectTitle.scss';

const ProjectTitle = ({ project }) => (
  <div className="ProjectTitle">
    <p><span>{project.title}</span></p>
  </div>
);

ProjectTitle.propTypes = {
  project: React.PropTypes.object.isRequired
};

export default ProjectTitle;



// WEBPACK FOOTER //
// ./src/components/ProjectTitle.js